/**
 * Menu Items Model
 * Centralized configuration for application menu items
 */

export const defaultMenuItems = [
  { title: "order", icon: "mdi-silverware", to: { name: "company-menu" } },
  {
    title: "meal_main",
    icon: "mdi-food-fork-drink",
    to: { name: "jelovnik" },
  },
  { title: "report", icon: "mdi-file-outline", to: { name: "izvestaj" } },
  {
    title: "report",
    icon: "mdi-file-outline",
    to: { name: "company-report" },
    rule: 'companyCanReport'
  },
  { title: "statistics", icon: "mdi-chart-areaspline", to: { name: "statistics" } },
  { title: "stock", icon: "mdi-warehouse", to: { name: "magacin" } },
  { title: "Trebovanje", icon: "mdi-warehouse", to: { name: "warehouse" } },
  { title: "companies", icon: "mdi-domain", to: { name: "firme" } },
  { title: "meals_main", icon: "mdi-food-drumstick", to: { name: "jela" } },
  {
    title: "groups",
    icon: "mdi-alpha-g-circle-outline",
    to: { name: "kategorije" },
  },
  {
    title: "menu_types",
    icon: "mdi-alpha-t-circle-outline",
    to: { name: "menu" },
  },
  { title: "groceri", icon: "mdi-cart", to: { name: "namirnice" } },
  { title: "gallery", icon: "mdi-file-image ", to: { name: "galerija" } },
  {
    title: "restaurants",
    icon: "mdi-silverware-fork-knife",
    to: { name: "restorani" },
  },
  // { title: "history", icon: "mdi-history", to: { name: "istorija" } },
];

/**
 * Menu items for specific user types
 */
export const userTypeMenuItems = {
  shop: [
    {
      title: "report",
      icon: "mdi-file-outline",
      to: { name: "izvestajFirma" },
    },
    {
      title: "meals_main",
      icon: "mdi-food-drumstick",
      to: { name: "jela" },
    },
    {
      title: "groups",
      icon: "mdi-alpha-g-circle-outline",
      to: { name: "kategorije" },
    },
  ],
  dostava: [
    {
      title: "orders",
      icon: "mdi-domain",
      to: { name: "delivery-user-orders" },
    },
  ],
  admin_delivery: [
    {
      title: "orders",
      icon: "mdi-domain",
      to: { name: "delivery-user-orders" },
    },
  ],
  supplier: [
    {
      title: "supplier_portal",
      icon: "mdi-truck-delivery",
      to: { name: "supplier-portal" },
    },
    {
      title: "restaurants",
      icon: "mdi-store-outline",
      to: { name: "supplier-restaurants" },
    },
    {
      title: "codebook",
      icon: "mdi-book-open-outline",
      to: { name: "supplier-codebook" },
    },
  ],
};

/**
 * Conditional menu items that can be added based on user context
 */
export const conditionalMenuItems = {
  companies_delivery: {
    title: "companies_delivery",
    icon: "mdi-domain",
    to: { name: "firme-dostava" },
  },
  guest_delivery: {
    title: "Isporuka-za-neregistrovane",
    icon: "mdi-currency-usd",
    to: { name: "guest-home" },
  },
  suppliers: {
    title: "suppliers",
    icon: "mdi-truck",
    to: { name: "suppliers" },
  },
  additional_meals: {
    title: "additional_meals",
    icon: "mdi-food-variant",
    to: { name: "additional-meals" },
  },
  location: {
    title: "location",
    icon: "mdi-map-marker",
    to: { name: "lokacija" },
  },
  branches: {
    title: "branches",
    icon: "mdi-file-outline",
    to: { name: "poslovnice" },
  },
  guest_report: {
    title: "guest_report",
    icon: "mdi-file-outline",
    to: { name: "guest-report" },
  },
  post_report: {
    title: "post_report",
    icon: "mdi-file-outline",
    to: { name: "izvestaj-posta" },
  },
  users_guest: {
    title: "Корисници - Гости",
    icon: "mdi mdi-account-multiple",
    to: { name: "users-guest-list" },
  },
  statistics: {
    title: "statistics",
    icon: "mdi-chart-areaspline",
    to: { name: "statistics" },
  },
  customers_restaurant: {
    title: "customers_restoran",
    icon: "mdi-domain",
    to: { name: "restoran-id-korisnici" },
  },
  settings: {
    title: "settings",
    icon: "mdi-cog",
    to: { path: "/restaurant/settings" },
  },
  messages: {
    title: "messages",
    icon: "mdi-message",
    to: { name: "poruke" },
  },
  delivery_post: {
    title: "delivery_post",
    icon: "mdi-post",
    to: { name: "posts" },
  },
  customerSelfReport: {
    title: "report",
    icon: "mdi-file-outline",
    to: { name: "customer-report" },
  },
  companyRestaurants: {
    title: "restaurants",
    icon: "mdi-store",
    to: { name: "customer-restaurants" },
  },
  companyLimits: {
    title: "limits",
    icon: "mdi-shield-account",
    to: { name: "company-limits" },
  },
  restaurantLimits: {
    title: "limits",
    icon: "mdi-shield-account",
    to: { name: "restaurant-limits" },
  },
};

/**
 * Helper function to get users menu item with dynamic params
 */
export function getUsersMenuItem(translate) {
  return {
    title: translate("users"),
    icon: "mdi-file-outline",
    to: { name: "korisnici" },
  };
}
